import { createFileRoute } from '@tanstack/react-router';
import TermsOfUse from '~/containers/TermsOfUse';

export const Route = createFileRoute('/terms')({
  component: TermsOfUse,
});
